import { render, staticRenderFns } from "./wxlogin.vue?vue&type=template&id=38854aa4&scoped=true"
import script from "./wxlogin.vue?vue&type=script&lang=ts"
export * from "./wxlogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38854aa4",
  null
  
)

export default component.exports